export default {
    "openai.access.refused": "您未获得授权或者授权已过期。"
}